import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { REGEX } from 'src/app/constants/regex';

@Component({
  selector: 'app-upi',
  templateUrl: './upi.component.html',
  styleUrls: ['./upi.component.scss']
})
export class UpiComponent implements OnInit {
  @Output() upiChanged = new EventEmitter<string>();
  UPI_FORM!: FormGroup;
  @Input() upi_banking_number: FormControl;
  constructor( private fb: FormBuilder, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.UPI_FORM = this.fb.group({
      upi_banking_number: new FormControl('', [Validators.required, Validators.pattern(REGEX.UPI)]),
    });
  }

  getUPIFormValue(): any {
    if (this.UPI_FORM.invalid) {
      this.UPI_FORM.markAllAsTouched();
      return null;
    }
    return this.UPI_FORM.value;
  }

  VALIDATE_UPI() {}
}
